
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pvc",
      function () {
        return require("private-next-pages/pvc/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pvc"])
      });
    }
  